/// <reference path="../smooth/smooth.ts" />
/// <reference path="../../../teva/storage/storage.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />

namespace OfficeGuy {
    export class Navigation {
        static Download_Init() {
            $(document.body).on("click.download", "a.og-download", function (Event) {
                return Navigation.DownloadTarget($(this), Event);
            });
        }
        static DownloadTarget($Link, Event) {
            if (Teva.Navigation.IsNewWindowEvent(Event))
                return true;

            Navigation.DownloadAsyncAddCookieIdentifier($Link.attr("href"));
            return false;
        }
        static DownloadAsyncAddCookieIdentifier(URL) {
            var CookieIdentifier = Common.GetDownloadIdentifierCookie();
            if (URL.indexOf("?") == -1)
                URL += "?cookieidentifier=" + CookieIdentifier;
            else
                URL += "&cookieidentifier=" + CookieIdentifier;
            Navigation.DownloadAsync(URL, CookieIdentifier);
        }
        static DownloadAsync(URL, CookieIdentifier = null) {
            if (URL.indexOf("?") == -1)
                URL += "?forcedownload=true";
            else
                URL += "&forcedownload=true";
            var MobileApplication = Teva.Storage.Cookie_Get("X-OG-Mobile");
            if (MobileApplication == "Android" || MobileApplication == "iPhone") {
                if (URL[0] == '/')
                    URL = Common.FullRootURL + URL;
                console.log("OG_Download:" + URL);
                return;
            }
            if (MobileApplication == "iPhone" || Common.IsiOS() || typeof document.createElement('a').download != "undefined") {
                var $Link = $(document.createElement('a'))
                    .attr("target", "_blank")
                    .attr("download", "download")
                    .attr("href", URL)[0];
                if (document.createEvent) {
                    var Event = document.createEvent('MouseEvents');
                    Event.initEvent('click', true, true);
                    $Link.dispatchEvent(Event);
                }
                else
                    $Link.click();
            }
            else {
                var $Frame = $(document.createElement('iframe'))
                    .css("display", "none")
                    .attr("src", URL)
                    .appendTo(document.body);
                setTimeout(function () { $Frame.remove(); }, 300000);
            }

            if (CookieIdentifier != null) {
                Navigation.Loading_Show();
                var Timer = setInterval(function () {
                    if (Teva.Storage.Cookie_Get("og_d_" + CookieIdentifier) != "") {
                        clearInterval(Timer);
                        Navigation.Loading_Hide();
                    }
                }, 50);
            }
        }

        static Redirect(URL: string, PreventModal: boolean = false): boolean {
            OfficeGuy.Smooth.LoadWithoutConfirmation(URL, false, PreventModal, null);
            return false;
        }

        static ClickRedirect(Event, Element, URL: string): boolean {
            if ($(Event.target).is("a") && Event.target != Element)
                return true;
            if (Teva.Navigation.IsNewWindowEvent(Event)) {
                window.open(URL);
                return false;
            }
            OfficeGuy.Smooth.LoadWithoutConfirmation(URL, false, false, $(Event.target));
            return false;
        }

        static LoadingCount = 0;
        static Loading_Show(WithOverlay = true): void {
            Navigation.LoadingCount++;
            if (Navigation.LoadingCount > 1)
                return;

            WithOverlay = true;

            var $LoadingContainer = $(".og-loading");
            if ($LoadingContainer.length != 0)
                return;

            $LoadingContainer = $(document.createElement('div'))
                .addClass("og-loading")
                .appendTo(document.body);

            if (WithOverlay) {
                $(document.createElement('div'))
                    .addClass("og-loading-overlay")
                    .appendTo($LoadingContainer)
                    .show()
                    .addClass("og-loading-overlay-visible");
            }

            $(document.createElement('div'))
                .addClass("og-loading-container")
                .append($(document.createElement('div'))
                    .addClass("og-loading-icon-container")
                    .append($(document.createElement('div'))
                        .addClass("og-loading-icon-icon"))
                )
                .appendTo($LoadingContainer)
                .show()
                .addClass("og-loading-container-visible");
        }
        static Loading_Hide(): void {
            Navigation.LoadingCount--;
            if (Navigation.LoadingCount > 0)
                return;

            var $LoadingContainer = $(".og-loading");
            $LoadingContainer.children().stop().fadeOut(100, function () {
                $LoadingContainer.remove();
            });
        }

        static ShowLightbox(URL, $RelativeElement, Position = null) {
            if ($RelativeElement) {
                var $LightboxElement = $RelativeElement.data("lightbox");
                if ($LightboxElement) {
                    $(document).trigger("click.Lightbox");
                    return false;
                }
            }
            Common.AjaxRequest({
                Method: "GET",
                URL: URL,
                SuccessMethod: function (HTML) {
                    Navigation.ShowLightboxInternal(HTML, $RelativeElement, Position);
                }
            });
            return false;
        }
        static ShowLightboxHTML(HTML, $RelativeElement, Position = null) {
            if ($RelativeElement) {
                var $LightboxElement = $RelativeElement.data("lightbox");
                if ($LightboxElement) {
                    $(document).trigger("click.Lightbox");
                    return false;
                }
            }
            Navigation.ShowLightboxInternal(HTML, $RelativeElement, Position);
            return false;
        }
        static ShowLightboxInternal(HTML, $RelativeElement, Position = null) {
            var $Element = $("<div>")
                .addClass("sumit-lightbox-container")
                .appendTo('body')
                .html(HTML);
            if ($RelativeElement) {
                $RelativeElement.data("lightbox", $Element);
                if (Position == 'full')
                    $Element.addClass("sumit-lightbox-full");
                else if (Position == 'fixedsidemenu')
                    $Element.addClass("sumit-lightbox-container-fixedsidemenu");
                else if (Position == 'below' || Position == null)
                    Teva.Positioning.PositionBelow($Element, $RelativeElement);
            }
            $Element.css("z-index", Teva.Positioning.GetNextZIndex());
            $Element.children().css("z-index", Teva.Positioning.GetNextZIndex());
            $(document).trigger("OfficeGuy.AjaxLoaded", $Element);
            Teva.Navigation.FocusOnFirstField($Element);

            var RemoveLightboxFunction = function () {
                $Element.fadeOut(200, function () {
                    $RelativeElement.removeData("lightbox");
                    $Element.remove()
                });
                $(document)
                    .off("click.Lightbox", ClickEvent)
                    .off("Teva.PageLoad", RemoveLightboxFunction);
            };
            var ClickEvent = function (Event) {
                if ($(Event.target).parents().filter($Element).length == 0) {
                    RemoveLightboxFunction();
                    Event.preventDefault();
                    Event.stopPropagation();
                    return false;
                }
            };
            $(document)
                .on("click.Lightbox", ClickEvent)
                .on("Teva.PageLoad", RemoveLightboxFunction);
            return $Element;
        }

        static Back(DefaultPath, ClearDirty?) {
            if (ClearDirty)
                OfficeGuy.Forms.ClearDirty();
            if (Smooth.StatesCount > 0) {
                if (Teva.SelectBox.VisibleMobileInstance == null) {
                    var Forced = true;
                    if (OfficeGuy.Modals.VisibleModals.length > 0) {
                        var VisibleModals = $(".modal");
                        for (var i = 0; i < VisibleModals.length; i++) {
                            if ($(VisibleModals[i]).data("modal-params").PushState)
                                Forced = false;
                        }
                    }
                    if (Forced)
                        Smooth.CurrentHref = ""; // This forces back
                }
                window.history.back();
            }
            else
                Navigation.Redirect(DefaultPath);
            return false;
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Navigation.Download_Init();
});
